import { Button } from "@inkblot-therapy/squid"
import { useTranslation } from "react-i18next"
import { Icon } from "../Icon"
import { useDialogConfig } from "../../hooks/useDialogConfig"
import { Dialog } from "../Dialog"
import { useNavigate } from "react-router-dom"

type UploadButtonsProps = {
  submitDisabled: boolean
  submitHandler: () => void
}

export const UploadActions = ({
  submitDisabled,
  submitHandler,
}: UploadButtonsProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const config = useDialogConfig()

  const onSubmit = () => {
    if (submitDisabled) return
    config.openDialog({
      title: t("client.form.dialogs.confirmV2.title"),
      description: t("client.form.dialogs.confirmV2.description"),
      confirmText: t("client.form.dialogs.confirmV2.confirmText"),
      cancelText: t("client.form.dialogs.confirmV2.cancelText"),
      variant: "confirmation",
      onConfirm: submitHandler,
    })
  }

  const handleBackToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  return (
    <div className="flex flex-row mt-5 mb-2 gap-4">
      <Button onClick={() => navigate("/ontario")} variant="outlined">
        <div className="flex gap-2 p-2">
          <Icon variant="ArrowLeft" />
          {t("client.buttons.previous")}
        </div>
      </Button>
      <div className="flex gap-4 ml-auto">
        <Button variant="outlined" onClick={handleBackToTop}>
          <div className="flex gap-2 p-2">
            <Icon variant="ArrowUp" className="mr-1" />
            {t("client.buttons.backToTop")}
          </div>
        </Button>
        <Button disabled={submitDisabled} onClick={onSubmit}>
          <div className="flex gap-2 p-2">
            {t("client.buttons.submitReferral")}
            <Icon variant="ArrowRight" />
          </div>
        </Button>
      </div>
      <Dialog {...config} buttonsFullWidth={true} />
    </div>
  )
}
